import { styled } from '@mui/material/styles';
import { Popper } from '@mui/material';

export const useStyles = styled({
  root: {
    color: '#fff',
    '& .MuiAutocomplete-input': {
      color: '#fff',
    },
    '& .MuiSvgIcon-root': {
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: '#fff',
    },
  },
  option: {
    '&:hover': {
      backgroundColor: '#F4686E',
      color: '#F4686E',
    },
  },
});

export const CustomPopper = styled(Popper)(({ theme }) => ({
  '.MuiAutocomplete-listbox': {
    backgroundColor: '#fff',
    color: '#585858',
    '& .MuiAutocomplete-option': {
      '&:hover': {
        backgroundColor: '#FBF4F4',
        color: '#F4686E',
        borderRadius: '45px',
      },
    },
  },
}));
